module.exports = __webpack_public_path__ + "static/media/santahat.e0a4efba.png";